import bowser from "bowser";

/**
 * Returns true if the current browser supports downsampling for web audio.
 * In other words, if the user's audio input device has a higher sample rate
 * than the sample rate of the `AudioContext` being used to work with the
 * audio, the browser will handle that without issue by downsampling the
 * audio input data to match the `AudioContext`'s sample rate.
 */
export function doesBrowserSupportDownsamplingAudio(): boolean {
  const isChromeIOS = bowser.chrome && bowser.ios;
  return !bowser.firefox && !bowser.safari && !isChromeIOS;
}
